import React from "react";
import { Typography, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const RULES = [
  {
    label: "Minimum 8 characters",
    test: (password) => password.length >= 8,
  },
  {
    label: "At least 1 uppercase letter",
    test: (password) => /[A-Z]/.test(password),
  },
  {
    label: "At least 1 lowercase letter",
    test: (password) => /[a-z]/.test(password),
  },
  {
    label: "At least 1 number",
    test: (password) => /[0-9]/.test(password),
  },
  {
    label: "At least 1 special character",
    test: (password) => /[^A-Za-z0-9]/.test(password),
  },
];

export default function PasswordRequirements({ password = "" }) {
  const hasTyped = password.length > 0;
  return (
    <Box sx={{ mt: 0.75 }}>
      <Typography
        variant="body2"
        sx={{
          fontSize: "0.875rem",
          fontWeight: 600,
          mb: 0.5,
          color: "text.secondary",
        }}
      >
        Password Requirements:
      </Typography>

      <Box component="ul" sx={{ pl: 2.5, m: 0 }}>
        {RULES.map((rule) => {
          const matched = rule.test(password);
          return (
            <Typography
              key={rule.label}
              component="li"
              variant="body2"
              sx={{
                fontSize: "0.875rem",
                lineHeight: 1.5,
                transition: "color 120ms ease",
                color: matched
                  ? "success.main"
                  : (theme) =>
                      theme.palette.mode === "dark"
                        ? hasTyped
                          ? "rgba(226,232,240,0.75)"
                          : "rgba(226,232,240,0.85)"
                        : "text.secondary",
              }}
            >
              {rule.label}
              {matched && (
                <CheckCircleOutlineIcon
                  sx={{
                    fontSize: 14,
                    ml: 0.6,
                    verticalAlign: "text-bottom",
                    color: "success.main",
                  }}
                />
              )}
            </Typography>
          );
        })}
      </Box>
    </Box>
  );
}
